import Rails from "@rails/ujs";
import Axios from "axios";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import toastr from "toastr";

export interface ReeditBtnProps {
  order_id: number;
}

const ReeditBtn = (props: ReeditBtnProps) => {
  const [show, setShow] = React.useState(false),
    [visibleIds, setVisibleIds] = React.useState<string[]>([]);

  function accept() {
    Axios({
      method: "POST",
      url: `/reedit_actions`,
      data: {
        order_id: props.order_id,
      },
      headers: {
        "X-CSRF-Token": Rails.csrfToken(),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        toastr.success("Action made successfully");
        setShow(false);
        setTimeout(() => {
          window.location.replace('/orders');
        }, 2000);

      })
      .catch((err) => {
        console.log(err);
        toastr.error("Action not made", err);
      });
  }

  function showInfo() {
    Axios({
      method: "GET",
      url: `/reedit_actions/new.json?order_id=${props.order_id}`,
      data: {},
      headers: {
        "X-CSRF-Token": Rails.csrfToken(),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        setVisibleIds(res.data["visible_id"].split(","));
        setShow(true);
      })
      .catch((err) => {
        console.log(err);
        toastr.error("Info error", err);
      });
  }

  function closeClicked(): void {
    setShow(false);
  }

  return (
    <div>
      <Button className="btn btn-danger" onClick={() => showInfo()}>
        Reedit Order
      </Button>

      <Modal show={show}>
        <Modal.Header closeButton>
          <Modal.Title>Reedit Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Following {visibleIds.length === 1 ? "order" : "orders"} will be
            deleted from PM:
            <ul>
              {visibleIds.map((id) => (
                <li key={id}>Order ID: {id}</li>
              ))}
            </ul>
          </div>
          Are you sure you want to reedit this order?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={closeClicked}>
            No
          </Button>

          <Button variant="primary" onClick={() => accept()}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default ReeditBtn;
